// *********************************
// CoolGames Builder JavaScript file
// *********************************
/**
 * Used for debugging the replay
 */
export var ReplayLogger = {};
// Make this true to enable the logger
ReplayLogger.isEnabled = false;
ReplayLogger._isRecording = false;
ReplayLogger._hashArray = [];
ReplayLogger.log = function (eventName) {
    if (!this.isEnabled) {
        return;
    }
    if (this._isRecording) {
        this._hashArray.push(eventName);
    }
};
ReplayLogger.startRecording = function () {
    if (!this.isEnabled) {
        return;
    }
    this._isRecording = true;
    this._hashArray = [];
};
ReplayLogger.stopRecording = function () {
    if (!this.isEnabled) {
        return;
    }
    this._isRecording = false;
    ReplayLogger.printRecording();
};
ReplayLogger.printRecording = function () {
    if (!this.isEnabled) {
        return;
    }
    var hashString = JSON.stringify(this._hashArray);
    while (hashString.indexOf(",") != -1) {
        hashString = hashString.replace(",", "\n");
    }
    console.log(hashString);
};
